export default function ({ app }) {
  const ta = document.createElement('script')
  ta.type = 'text/javascript'
  ta.async = true
  ta.src =
    'https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=BSI5H65EO40H95665EMG'

  const s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(ta, s)
}
